import { ca } from '@cian/analytics';

export function trackFavoritesLinkClick(offerId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'click',
    label: 'to_favorites',
    products: [
      {
        id: offerId,
      },
    ],
  });
}
